export enum AppEvent {
  NAVIGATE = 'NAVIGATE',
  SHOW_NOTIFICATION = 'SHOW_NOTIFICATION',
  AI_PLAN_LIMIT = 'AI_PLAN_LIMIT',
}
